import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken, removeToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.NODE_ENV  === 'development' ?
  'http://127.0.0.1:9057' : process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 15000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      if (config.url.startsWith('/supplier')) {
        config.headers['vanToken'] = getToken()
      } else {
        config.headers['accessToken'] = getToken()
      }
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data ? response.data : null
    if (!res.status) {
      Message({
        message: res.data.errorMessage || 'Error',
        type: 'error',
        duration: 3 * 1000
      })
    }
    return res
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        case 403:
          if (error.config.url.includes('/login')) {
            Message({
              message: error.response.data.data.errorMessage,
              type: 'error',
              duration: 3 * 1000
            })
          } else {
            removeToken()
            router.replace({
              path: '/login'
            })
            store.commit('app/TOGGLE_LOADING', false)
          }
          break
        case 400:
          Message({
            message: 'Please check the correct information',
            type: 'error',
            duration: 3 * 1000
          })
          break
          // return Promise.reject(error.response.data)
        default:
          Message({
            message: 'error',
            type: 'error',
            duration: 3 * 1000
          })
          // return Promise.reject(error.response.data)
      }
    } else {
      Message({
        message: '请求超时～',
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error.response.data)
  }
)

export default service
